import { useMutation } from "react-query";
import { patchMultiPart } from "../../data";

export const useUploadAttribute = () => {
    return useMutation(({ file }) => {
        const formData = new FormData();
        formData.append("file", file);
        formData.append("workflowType", "3");

        return patchMultiPart("/file-uploads/BulkUploadAttributeTooltips", formData);
    });
};
